"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decryptRaw = exports.encryptRaw = exports.encryptFile = exports.decryptFile = exports.encryptURL = exports.decryptURL = exports.readAsArrayBuffer = exports.readAsDataURL = void 0;
var Base64 = require("./base64");
function readAsDataURL(file) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function (event) {
            var result = event.target.result;
            resolve(result);
        };
        reader.onerror = function (event) { return reject(event); };
        reader.readAsDataURL(file);
    });
}
exports.readAsDataURL = readAsDataURL;
function readAsArrayBuffer(file) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function (event) {
            var result = event.target.result;
            resolve(result);
        };
        reader.onerror = function (event) { return reject(event); };
        reader.readAsArrayBuffer(file);
    });
}
exports.readAsArrayBuffer = readAsArrayBuffer;
function decryptURL(_a) {
    var url = _a.url, key = _a.key, iv = _a.iv;
    return __awaiter(this, void 0, void 0, function () {
        var result, ciphertext;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4, fetch(url)];
                case 1:
                    result = _b.sent();
                    if (!result.ok) return [3, 4];
                    return [4, result.arrayBuffer()];
                case 2:
                    ciphertext = _b.sent();
                    return [4, decryptRaw({ key: key, iv: iv, ciphertext: ciphertext })];
                case 3: return [2, _b.sent()];
                case 4: throw new Error("Failed to download url");
            }
        });
    });
}
exports.decryptURL = decryptURL;
function encryptURL(url) {
    return __awaiter(this, void 0, void 0, function () {
        var result, ciphertext;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, fetch(url)];
                case 1:
                    result = _a.sent();
                    if (!result.ok) return [3, 4];
                    return [4, result.arrayBuffer()];
                case 2:
                    ciphertext = _a.sent();
                    return [4, encryptRaw(ciphertext)];
                case 3: return [2, _a.sent()];
                case 4: throw new Error("Failed to download url");
            }
        });
    });
}
exports.encryptURL = encryptURL;
function decryptFile(_a) {
    var iv = _a.iv, key = _a.key, file = _a.file;
    return __awaiter(this, void 0, void 0, function () {
        var ciphertext;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4, readAsArrayBuffer(file)];
                case 1:
                    ciphertext = _b.sent();
                    return [4, decryptRaw({ key: key, iv: iv, ciphertext: ciphertext })];
                case 2: return [2, _b.sent()];
            }
        });
    });
}
exports.decryptFile = decryptFile;
function encryptFile(file) {
    return __awaiter(this, void 0, void 0, function () {
        var buffer;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, readAsArrayBuffer(file)];
                case 1:
                    buffer = _a.sent();
                    return [4, encryptRaw(buffer)];
                case 2: return [2, _a.sent()];
            }
        });
    });
}
exports.encryptFile = encryptFile;
function encryptRaw(buffer) {
    return __awaiter(this, void 0, void 0, function () {
        var key, exportedKey, iv, ciphertext;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, window.crypto.subtle.generateKey({
                        name: 'AES-GCM',
                        length: 256,
                    }, true, ['encrypt', 'decrypt'])];
                case 1:
                    key = _a.sent();
                    return [4, window.crypto.subtle.exportKey('raw', key)];
                case 2:
                    exportedKey = _a.sent();
                    iv = window.crypto.getRandomValues(new Uint8Array(12));
                    return [4, window.crypto.subtle.encrypt({ name: 'AES-GCM', iv: iv, tagLength: 128 }, key, buffer)];
                case 3:
                    ciphertext = _a.sent();
                    return [2, {
                            key: Base64.encodeArrayBuffer(exportedKey),
                            iv: Base64.encodeUint8Array(iv),
                            ciphertext: ciphertext,
                        }];
            }
        });
    });
}
exports.encryptRaw = encryptRaw;
function decryptRaw(_a) {
    var iv = _a.iv, key = _a.key, ciphertext = _a.ciphertext;
    return __awaiter(this, void 0, void 0, function () {
        var ivBuffer, rawKey, cryptoKey;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    ivBuffer = Base64.decodeArrayBuffer(iv);
                    rawKey = Base64.decodeUint8Array(key);
                    return [4, window.crypto.subtle.importKey('raw', rawKey, 'AES-GCM', true, ['encrypt', 'decrypt'])];
                case 1:
                    cryptoKey = _b.sent();
                    return [4, window.crypto.subtle.decrypt({ name: 'AES-GCM', iv: ivBuffer }, cryptoKey, ciphertext)];
                case 2: return [2, _b.sent()];
            }
        });
    });
}
exports.decryptRaw = decryptRaw;
//# sourceMappingURL=encryption.js.map